import { NewsletterFrequency } from '../enums/newsletter-frequency';

export interface INewsletterCategory extends INewsletterBaseCategory {
  default: boolean;
  special: string;
  description: string;
  descriptionResource: string;
  frequency: NewsletterFrequency;
  lowerFreqAlt: number[];
  lowerFreqAltDefault: number;
  titleResource: string;
  imageUrl: string;
  displayOnce: boolean;
  createdDate: string;
  updatedDate: string;
  createdBy: string;
  updatedBy: string;
  region: string;
}
export interface INewsletterBaseCategory {
  id: number;
  name: string;
}
export class NewsletterBaseCategory {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
